import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { CO2ReportsService } from "../co2-report.service";
import { NotificationService } from "../../../common/component/notification/notification.service";
import { SharedService } from "../../../services/SharedService";
import { CO2MapBySapPlantReportAllData, CO2MapBySapPlantReportFilters, OtherPlantData, PlantData, BullsEyeData, ProposedPlantData } from "../types/CO2MapBySAPPlant";
import { DxDataGridComponent, DxDropDownBoxComponent, DxListComponent } from 'devextreme-angular';
import { Workbook } from 'exceljs';
import { exportDataGrid } from 'devextreme/excel_exporter';
import saveAs from 'file-saver';
import { forkJoin } from 'rxjs';
import { Loader } from "@googlemaps/js-api-loader";
import { environment } from "src/environments/environment";
import * as wkt from 'wkt';
import * as geojson from "geojson";

@Component({
  selector: 'app-co2-map-by-sapplant',
  templateUrl: './co2-map-by-sapplant.component.html',
  styleUrls: ['./co2-map-by-sapplant.component.scss']
})
export class CO2MapBySapplantComponent implements OnInit, AfterViewInit {

  isLoadPanelVisible: boolean = true;
  countryData: any[] = [];
  countryValue: string[] = ["US"];
  plantData: any[] = [];
  plantValue: number[] = [];
  segmentData: any[] = [];
  segmentValue: number[] = [];
  radiobtndata = [];
  cancrossborders: boolean;
  showRings: boolean;
  disableallfilters: boolean = true;
  miles: number;
  numberPattern: any = /^(0|[1-9][0-9]*)$/;
  decimalPattern: any = /^\d*\.?\d*$/;
  filters: CO2MapBySapPlantReportFilters;
  dataSource: any;
  showGrid: boolean = false;
  reportData: CO2MapBySapPlantReportAllData;
  compplantData: PlantData[];
  associtedPlantData: PlantData[];
  bullsEyeData: BullsEyeData[];
  proposedPlantData: ProposedPlantData[];
  mapMarkers: any = [];
  markers: any[] = [];
  planttitle: string;
  map: google.maps.Map;
  infoWindow: google.maps.InfoWindow;
  google: any;
  @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;
  @ViewChild('countrylist', { static: false }) countrylist: DxListComponent;
  @ViewChild('plantslist', { static: false }) plantslist: DxListComponent;
  @ViewChild('segmentlist', { static: false }) segmentlist: DxListComponent;

  constructor(private co2ReportSvc: CO2ReportsService,
    private sharedSvc: SharedService,
    private notificationService: NotificationService) { }

  ngOnInit(): void {
    this.radiobtndata = [{ text: "True", value: true }, { text: "False", value: false }];
    this.cancrossborders = true;
    this.showRings = true;
    this.miles = 150;
    this.getUserCountries();
    this.getglobalindustrysegments();
  }

  ngAfterViewInit(): void {

    //This loads the google javascript API once.
    new Loader({
      apiKey: environment.gmaps,
      version: 'weekly'
    }).load().then((google) => {
      this.google = google;
    });

  }

  getUserCountries() {
    this.co2ReportSvc.getUserCountries(this.sharedSvc.UserRoles.apexId, this.sharedSvc.UserRoles.isIGAdmin, this.sharedSvc.UserRoles.isIGPower, this.sharedSvc.UserRoles.isIGAmerica, this.sharedSvc.UserRoles.isIGEurope, this.sharedSvc.UserRoles.isIGAsia, false, false).subscribe({
      next: data => {
        this.countryData = data;
        this.getallplantsforcountries();
      },
      error: (error: any) => {
        this.isLoadPanelVisible = false;
        this.notificationService.alert("error", "Error while fetching countries. ", error);
      }
    })
  }

  getallplantsforcountries() {
    this.co2ReportSvc.getallplantsforcountries(this.countryValue, this.sharedSvc.UserRoles.isIGPower).subscribe({
      next: data => {
        this.plantData = data;
        this.disableallfilters = false;
        this.isLoadPanelVisible = false;
      },
      error: (error: any) => {
        this.isLoadPanelVisible = false;
        this.notificationService.alert("error", "Error while fetching plants. ", error);
      }
    })
  }

  getglobalindustrysegments() {
    this.co2ReportSvc.getglobalindustrysegments().subscribe({
      next: data => {
        this.segmentData = data;
      },
      error: (error: any) => {
        this.isLoadPanelVisible = false;
        this.notificationService.alert("error", "Error while fetching industry segments. ", error);
      }
    });
  }

  onCountryDropDownBoxValueChanged(e) {
    this.updateSelection((this.countrylist && this.countrylist.instance), this.countryValue);
  }

  updateSelection(list, value) {
    if (!list) return;

    if (!value) {
      list.unselectAll();
    }
  }

  oncountryListSelectionChanged(e) {
    this.countryValue = this.countrylist.selectedItemKeys;
  }

  onPlantsDropDownBoxValueChanged(e) {
    this.updateSelection((this.plantslist && this.plantslist.instance), this.plantValue);
  }

  onplantListSelectionChanged(e) {
    this.plantValue = this.plantslist.selectedItemKeys;
  }

  onSegmentsDropDownBoxValueChanged(e) {
    this.updateSelection((this.segmentlist && this.segmentlist.instance), this.segmentValue);
  }

  onSegmentListSelectionChanged(e) {
    this.segmentValue = this.segmentlist.selectedItemKeys;
  }

  viewReport() {
    this.Maketitle();
    this.isLoadPanelVisible = true;
    this.filters = new CO2MapBySapPlantReportFilters(this.plantValue, this.segmentValue, this.cancrossborders, this.miles);
    var reportdata = this.co2ReportSvc.getCO2MapBySAPReport(this.filters);
    var otherplants = this.co2ReportSvc.getallotherplants(this.miles, this.plantValue);
    forkJoin([reportdata, otherplants]).subscribe(([reportdata, otherplants]) => {
      this.reportData = reportdata;
      this.compplantData = otherplants.compPlants;
      this.associtedPlantData = otherplants.associtedPlants;
      this.bullsEyeData = otherplants.bullsEyePlants;
      this.proposedPlantData = otherplants.proposedPlants;
      this.showGrid = true;
      this.dataSource = reportdata.groupedCO2MapBySapPlantReportsList;
      this.isLoadPanelVisible = false;
      if (this.reportData.cO2MapBySapPlantReportList.length > 0)
        this.initMap();
    })
  }

  Maketitle() {
    this.planttitle = "";
    this.plantValue.forEach(element => {
      this.planttitle += this.plantData.filter(x => x.siteID == element)[0].siteCombined + " + ";
    });
    this.planttitle = this.planttitle.substring(0, this.planttitle.length - 2);
  }

  async initMap() {
    const loader = new Loader({
      apiKey: environment.gmaps,
      version: 'weekly'
    });

    loader.load().then((google) => {
      this.mapMarkers = [];
      this.map = new google.maps.Map(document.getElementById("map") as HTMLElement, {
        center: { lat: this.reportData.cO2MapBySapPlantReportList[0].latitude, lng: this.reportData.cO2MapBySapPlantReportList[0].longitude },
        zoom: 5,
        mapTypeId: 'terrain',
        mapId: environment.mapId
      });

      this.infoWindow = new google.maps.InfoWindow();
      const industrySegLegend = document.getElementById("industrySegmentLegend") as HTMLElement;
      const productLegend = document.getElementById("productLegend") as HTMLElement;
      industrySegLegend.innerHTML = '<div _ngcontent-ijm-c390="" style="text-align: center;"><b _ngcontent-ijm-c390="">Industry Segment</b></div><hr _ngcontent-ijm-c390="">';
      productLegend.innerHTML = '<div _ngcontent-ijm-c390="" style="text-align: center;"><b _ngcontent-ijm-c390="">Prod</b></div><hr _ngcontent-ijm-c390="">';

      if (this.reportData.cO2MapBySapPlantReportList.length > 0) {
        industrySegLegend.hidden = false;
      } else {
        industrySegLegend.hidden = true;
      }

      let colorcodes = [];

      this.reportData.cO2MapBySapPlantReportList.forEach((item, index) => {
        if (colorcodes.indexOf(item.globalIndustrySegment) < 0) {
          const div = document.createElement("div");
          div.innerHTML = '<svg height="20" width="40">  <circle cx="15" cy="12" r="' + 5 + '" stroke-width="1" fill="' + item.colour + '" /> </svg>' + item.globalIndustrySegment;
          industrySegLegend.appendChild(div);
          colorcodes.push(item.globalIndustrySegment);
        }
      });

      const div = document.createElement("div");
      div.innerHTML = '<svg height="20" width="40">  <circle cx="15" cy="12" r="' + 5 + '" stroke-width="1" fill="White" /> </svg> CO2';
      productLegend.appendChild(div);

      for (let i of this.reportData.cO2MapBySapPlantReportList) {
        const tempMarker = new google.maps.Marker({
          position: { lat: i.latitude, lng: i.longitude },
          icon: {
            path: google.maps.SymbolPath.CIRCLE,
            scale: 4,
            fillOpacity: 1,
            strokeColor: i.colour,
            fillColor: i.colour
          }, map: this.map
        });
        this.mapMarkers.push(tempMarker);
      }

      for (let i of this.compplantData) {
        const tempMarker = new google.maps.Marker({
          position: { lat: i.latitude, lng: i.longitude },
          icon: {
            path: google.maps.SymbolPath.CIRCLE,
            scale: 4,
            fillOpacity: 1,
            strokeColor: "black",
            fillColor: "black"
          }, map: this.map
        });
        this.mapMarkers.push(tempMarker);
      }

      this.associtedPlantData.forEach(element => {
        let marker = new google.maps.Marker({
          animation: google.maps.Animation.DROP,
          title: element.siteName,
          position: { lat: element.latitude, lng: element.longitude }
        });

        marker.setMap(this.map);
      });

      this.proposedPlantData.forEach(element => {
        let marker = new google.maps.Marker({
          animation: google.maps.Animation.DROP,
          title: element.siteName,
          position: { lat: element.latitude, lng: element.longitude }
        });
        marker.setMap(this.map);
        let polycoords = wkt.parse(element.miles125);
        let _geoData: Array<any> = new Array<any>();
        _geoData.push({
          "fillColor": "none",
          "fillOpacity": 0.5,
          "title": "",
          "strokeWeight": 3,
          "strokeColor": "#10107d",
          "strokeOpacity": 1,
          "geo": polycoords
        });
        let featureCollection = geojson.parse(_geoData, { GeoJSON: 'geo' });
        this.map.data.addGeoJson(featureCollection);
      });

      if (this.showRings) {
        this.plotBullsEye(this.map);
      }

      this.map.data.setStyle(function (feature) {
        return {
          strokeColor: feature.getProperty("strokeColor"),
          strokeOpacity: feature.getProperty("strokeOpacity"),
          strokeWeight: feature.getProperty("strokeWeight"),
          title: feature.getProperty("title"),
          fillColor: feature.getProperty("fillColor"),
          fillOpacity: feature.getProperty("fillOpacity"),
        }
      });
    });
  }

  async plotBullsEye(map: google.maps.Map){
    this.bullsEyeData.forEach(element => {
      let polycoords = wkt.parse(element.bullseye);
      let _geoDatabull: Array<any> = new Array<any>();
      _geoDatabull.push({
        "fillColor": "none",
        "fillOpacity": 0,
        "strokeWeight": 1,
        "strokeColor": "#000000",
        "title": element.dist + " miles",
        "strokeOpacity": 1,
        "geo": polycoords
      });
      let featureCollection = geojson.parse(_geoDatabull, { GeoJSON: 'geo' });
      this.map.data.addGeoJson(featureCollection);
    });

    const { AdvancedMarkerElement } = await this.google.maps.importLibrary("marker");
    const parser = new DOMParser();
    this.bullsEyeData.forEach(item => {
      let point = wkt.parse(item.geoPoint);
      let svgText = `<svg xmlns="http://www.w3.org/2000/svg" height="30" width="60">
                    <text x="5" y="28" font-size="12" 
                      font-weight="bold" fill="black">${item.dist} miles</text>
                  </svg>`;

      let marker = new AdvancedMarkerElement({
        map: this.map,
        position: { lat: point.coordinates[1], lng: point.coordinates[0] },
        content: parser.parseFromString(svgText, 'image/svg+xml').documentElement,
      });
    });
  }

  exportExcel(e) {
    this.isLoadPanelVisible = true;
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Main sheet');
    exportDataGrid({
      component: this.dataGrid.instance,
      worksheet: worksheet
    }).then(function () {
      workbook.xlsx.writeBuffer()
        .then(function (buffer: BlobPart) {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'CO2MapBySAPPlant.xlsx');
        });
    }).then(() => {
      this.isLoadPanelVisible = false;
    });

    e.cancel = true;
  }

  getCountValueOnly(arg) {
    return arg.value;
  }

  getValueToOneDecimal(arg) {
    return arg.value.toFixed(1);
  }

  getTextTotal(arg) {
    return 'Total';
  }



}